/**
 * @param {string | number} [date]
 * @param {boolean} [showTime] */
export const formatDate = (date, showTime) => {
  /** @type {Intl.DateTimeFormatOptions} */
  if (!date) {
    return '';
  }
  /** @type {Intl.DateTimeFormatOptions} */
  const dateOptions = { year: 'numeric', month: 'long', day: 'numeric' };
  if (showTime) {
    dateOptions.hour = 'numeric';
    dateOptions.minute = 'numeric';
  }
  return new Intl.DateTimeFormat('en-US', dateOptions).format(new Date(date));
};
